import React from "react";
import { CheckCircle2, AlertTriangle, XCircle, FileCheck, ScrollText } from "lucide-react";

const ICONS = {
  purpose_declared: ScrollText,
  confirm: CheckCircle2,
  sign_off: CheckCircle2,
  refuse: XCircle,
  escalate: AlertTriangle,
};

function ReviewIcon({ action }) {
  const Cmp = ICONS[action] || FileCheck;
  return <Cmp size={16} className="text-[var(--ink-heading)]" />;
}

export default function ReviewTimeline({ items }) {
  if (!items || items.length === 0) {
    return (
      <p className="text-sm text-[var(--ink-muted)] italic" data-testid="timeline-empty">
        No review actions yet.
      </p>
    );
  }
  return (
    <ol className="border-l border-slate-200 ml-2 space-y-6" data-testid="review-timeline">
      {items.map((it, idx) => (
        <li key={idx} className="relative pl-6">
          <span className="absolute -left-[7px] top-1 w-3 h-3 bg-white border border-slate-300 flex items-center justify-center">
            <ReviewIcon action={it.action} />
          </span>
          <div className="flex items-baseline gap-3 flex-wrap">
            <span className="eyebrow text-[var(--ink-mono)]">{it.role.replace(/_/g, " ")}</span>
            <span className="text-sm text-[var(--ink-heading)] font-medium">{it.action.replace(/_/g, " ")}</span>
            <span className="text-xs text-[var(--ink-muted)] font-mono-ui">
              {new Date(it.timestamp_utc).toLocaleString()}
            </span>
          </div>
          <p className="text-sm text-[var(--ink-secondary)] mt-1">
            <span className="text-[var(--ink-mono)]">{it.actor}</span>
            {it.note ? <> — {it.note}</> : null}
          </p>
        </li>
      ))}
    </ol>
  );
}
